import { fetchCurrentUser } from '../../ducks/user.duck';
import { onGetNotificationsV2 } from '../../util/api';

export const NOTIFICATION_V2_REQUEST = 'app/NotificationPageV2/NOTIFICATION_V2_REQUEST';
export const NOTIFICATION_V2_SUCCESS = 'app/NotificationPageV2/NOTIFICATION_V2_SUCCESS';
export const NOTIFICATION_V2_ERROR = 'app/NotificationPageV2/NOTIFICATION_V2_ERROR';

export const NOTIFICATION_V2_LOAD_MORE_REQUEST =
  'app/NotificationPageV2/NOTIFICATION_V2_LOAD_MORE_REQUEST';
export const NOTIFICATION_V2_LOAD_MORE_SUCCESS =
  'app/NotificationPageV2/NOTIFICATION_V2_LOAD_MORE_SUCCESS';
export const NOTIFICATION_V2_LOAD_MORE_ERROR =
  'app/NotificationPageV2/NOTIFICATION_V2_LOAD_MORE_ERROR';

const initialState = {
  loading: false,
  loadingMore: false,
  data: [],
  page: 1,
  totalPages: 0,
  hasMore: false,
  error: null,
};

const notificationPageV2Reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case NOTIFICATION_V2_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case NOTIFICATION_V2_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        error: null,
        data: action.payload.notifications || [],
        page: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        hasMore: Boolean(action.payload.hasMore),
      };
    case NOTIFICATION_V2_ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        error: action.payload,
      };
    case NOTIFICATION_V2_LOAD_MORE_REQUEST:
      return {
        ...state,
        loadingMore: true,
        error: null,
      };
    case NOTIFICATION_V2_LOAD_MORE_SUCCESS:
      return {
        ...state,
        loadingMore: false,
        error: null,
        data: [...state.data, ...(action.payload.notifications || [])],
        page: action.payload.currentPage || state.page,
        totalPages: action.payload.totalPages || state.totalPages,
        hasMore: Boolean(action.payload.hasMore),
      };
    case NOTIFICATION_V2_LOAD_MORE_ERROR:
      return {
        ...state,
        loadingMore: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default notificationPageV2Reducer;

export const notificationV2Request = () => ({
  type: NOTIFICATION_V2_REQUEST,
});

export const notificationV2Success = payload => ({
  type: NOTIFICATION_V2_SUCCESS,
  payload,
});

export const notificationV2Error = payload => ({
  type: NOTIFICATION_V2_ERROR,
  payload,
});

export const notificationV2LoadMoreRequest = () => ({
  type: NOTIFICATION_V2_LOAD_MORE_REQUEST,
});

export const notificationV2LoadMoreSuccess = payload => ({
  type: NOTIFICATION_V2_LOAD_MORE_SUCCESS,
  payload,
});

export const notificationV2LoadMoreError = payload => ({
  type: NOTIFICATION_V2_LOAD_MORE_ERROR,
  payload,
});

const fetchPage = ({ userId, userType, page, perPage = 20 }) => {
  return onGetNotificationsV2({
    userId,
    userType,
    page,
    perPage,
    markAsRead: true,
  });
};

export const loadData = () => async (dispatch, getState) => {
  await dispatch(fetchCurrentUser());

  const { currentUser } = getState()?.user || {};
  const userId = currentUser?.id?.uuid;
  const appUserType = currentUser?.attributes?.profile?.publicData?.userType;
  const userType = appUserType === 'provider' ? 'merchant' : 'customer';

  if (!userId) {
    dispatch(notificationV2Error('User ID is missing'));
    return Promise.resolve();
  }

  dispatch(notificationV2Request());

  return fetchPage({ userId, userType, page: 1 })
    .then(res => {
      dispatch(
        notificationV2Success({
          notifications: res?.notifications || [],
          currentPage: res?.current_page || 1,
          totalPages: res?.total_pages || 0,
          hasMore: Boolean(res?.has_more),
        })
      );
    })
    .catch(error => {
      dispatch(notificationV2Error(error?.message || 'Error loading notifications'));
    });
};

export const loadMoreNotifications = () => async (dispatch, getState) => {
  const state = getState();
  const pageState = state?.NotificationPageV2 || initialState;

  if (pageState.loading || pageState.loadingMore || !pageState.hasMore) {
    return Promise.resolve();
  }

  const userId = state?.user?.currentUser?.id?.uuid;
  const appUserType = state?.user?.currentUser?.attributes?.profile?.publicData?.userType;
  const userType = appUserType === 'provider' ? 'merchant' : 'customer';
  if (!userId) {
    dispatch(notificationV2LoadMoreError('User ID is missing'));
    return Promise.resolve();
  }

  const nextPage = (pageState.page || 1) + 1;
  dispatch(notificationV2LoadMoreRequest());

  return fetchPage({ userId, userType, page: nextPage })
    .then(res => {
      dispatch(
        notificationV2LoadMoreSuccess({
          notifications: res?.notifications || [],
          currentPage: res?.current_page || nextPage,
          totalPages: res?.total_pages || pageState.totalPages,
          hasMore: Boolean(res?.has_more),
        })
      );
    })
    .catch(error => {
      dispatch(notificationV2LoadMoreError(error?.message || 'Error loading more notifications'));
    });
};
